import { observable } from 'mobx';
import createComponentStore from '@src/mobx-store/component-store/create-component-store';
import { props } from '@src/utils/link-store';
import AccountInfo from '@src/components/account-info/index';

/**
 * 父级组件
 * @type {{new(Object=): ComponentStore, _ObserverComponent: *, prototype: ComponentStore}}
 */
const ComponentStore = createComponentStore(AccountInfo);

/**
 * AnimateCss 动画库组件 store
 */
export default class AccountInfoStore extends ComponentStore {
  /**
   * @type {string} [username] - 登录成功用户名, 当传入空(如空字符串'', null, undefined 等)内部组件认定为 "未登录" 状态
   */
  @props
  @observable
  username;
  /**
   * @type {boolean} [isLoginModalVisible] - 登录弹窗是否显示
   */
  @props
  @observable
  isLoginModalVisible;
  /**
   * @type {Function} [onLoginSuccess] - 登录成功回调
   * - {string} username: 登录成功回调: 用户名
   * onLoginSuccess(username)
   */
  @props
  @observable
  onLoginSuccess;
  /**
   * @type {boolean} [isUsingMaskToUsername] - 是否在用户名上使用掩码
   * @default 默认: true
   */
  @props
  @observable
  isUsingMaskToUsername;
  /**
   * @type {boolean} [isAllowLogout] - 是否允许登出, 使用场景如: 在非通行证账户登录下, 不允许用户手动登出, 所以开发者可以使用该属性自行控制
   * @default 默认: true
   */
  @props
  @observable
  isAllowLogout;
  /**
   * @type {string} [usernameMaskSymbol] - 用户名掩码符号
   * @default 默认: "*"
   */
  @props
  @observable
  usernameMaskSymbol;
  /**
   * @type {Function} [onLogout] - 登出成功回调
   */
  @props
  @observable
  onLogoutSuccess;
  /**
   * @type {Function} [onBeforeLogoutSuccess] - 在登出成功前回调, 开发者可以选择在此加入如: 登出成功后直接刷新页面, 支持 promise 等待
   * @default 默认: 组件内部弹出"退出成功"吐司
   */
  @props
  @observable
  onBeforeLogoutSuccess;
  /**
   * @type {Function} [发起登出请求] - 发起登出请求
   * @default 默认: 直接使用了 '@src/services/general' logout [金山通行证]登出方法
   */
  @props
  @observable
  makeLogoutRequest;

  /**
   * @type {Function} [renderDisplayUsername] - 渲染用于登录成功的用户名展示, 默认参数签名如下:
   *
   * - {string} displayUsername: 展示用户名
   * - {object} accountInfoContext: accountInfo 组件内部环境的 this, 开发者可以自行使用内部 this 调取相关参数
   * renderDisplayUsername(displayUsername, accountInfoContext)
   *
   * @default 默认:
   * renderDisplayUsername(displayUsername, accountInfoContext) {
   *   return <React.Fragment>您好，{displayUsername}</React.Fragment>;
   * }
   *
   * 输出结果: 您好, xsj*****帅
   *
   */
  @props
  @observable
  renderDisplayUsername;
  /**
   * @type {Function} [renderLoginDisplayContent] - 渲染登录展示内容, 默认参数签名如下:
   *
   * - {Function} onLogin 用于"触发登录"回调
   * renderLoginDisplayContent(onLogin)
   *
   * @default 默认:
   * renderLoginDisplayContent(onLogin) {
   *  return (
   *    <React.Fragment>
   *      您好,请<Link className={styles.login} onClick={onLogin}>
   *        [登录]
   *      </Link>
   *    </React.Fragment>
   *  );
   * }
   */
  @props
  @observable
  renderLoginDisplayContent;
}
